export const formatPercent = (value: number) => `${value * 100}%`;
export const formatPercentWithoutMultiply = (value: number) => `${value}%`;
